module.exports = __webpack_public_path__ + "img/drag.b6e61667.svg";